import { postSnapLiked as postSnapLikedApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type PostSnapLikedServiceRequest,
  PostSnapLikedServiceRequestSchema,
  type PostSnapLikedServiceResponse,
  PostSnapLikedServiceResponseSchema,
} from './post-snap-liked.dto';

export const postSnapLikedService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(PostSnapLikedServiceRequestSchema),
    async (request: PostSnapLikedServiceRequest): Promise<PostSnapLikedServiceResponse> => {
      const apiResponse = await postSnapLikedApi({ snapId: request.snapId });
      return {
        success: apiResponse.meta?.result === 'SUCCESS',
      };
    },
    validateServiceResponse(PostSnapLikedServiceResponseSchema),
  ),
);
